// @flow
import MovingRect from './MovingRect';
import type { MeasureEntryType } from './MovingRect';

export default MovingRect;
export type { MeasureEntryType };
